import { Box, useMediaQuery, useTheme } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { returnStringByLang, useWindowSize } from "../../utils";
import { useTranslation } from "react-i18next";

const PostStatusBarChart = ({ postStatuses }) => {
  const { i18n } = useTranslation();
  const namesArray = postStatuses.map((status) => returnStringByLang(status.postStatus, i18n.language));
  const valuesArray = postStatuses.map((status) => status.postsCount);
  const colorsArray = postStatuses.map((status) => status.postStatus.color);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { width } = useWindowSize();
  // const chartWidth = Math.min(width - 80, 1000);

  return (
    <Box sx={{ width: '100%' }}>
      <BarChart
        width={width - (isMobile ? 50 : 280)}
        height={300}
        borderRadius={2}
        series={[{ data: valuesArray, id: "cId" }]}
        xAxis={[
          {
            data: namesArray,
            scaleType: "band",
            colorMap: {
              type: "ordinal",
              values: namesArray,
              colors: colorsArray,
            },
          },
        ]}
      />
    </Box>
  );
}

export default PostStatusBarChart;